var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "treatment-add-ons" }, [
    _c(
      "div",
      { staticClass: "treatment-add-ons__wrapper" },
      [
        _c("transition", { attrs: { name: "slide-fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAddOns,
                  expression: "showAddOns",
                },
              ],
              staticClass: "treatment-add-ons__list",
            },
            _vm._l(_vm.treatmentAddOns, function (addOn, index) {
              return _c("TreatmentAddOn", {
                key: "add-on-" + index,
                attrs: { "add-on": addOn },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "treatment-add-ons__options",
            class: { "--opened": _vm.showAddOns },
          },
          [
            !_vm.showAddOns
              ? _c("span", { staticClass: "treatment-add-ons__quantity" }, [
                  _vm._v("1 Added"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "treatment-add-ons__toggle",
                attrs: { "aria-expanded": _vm.showAddOns ? "true" : "false" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleAddOnsList($event)
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.toggleAddOnsList($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(!_vm.showAddOns ? "Show Add-Ons" : "Hide Add-Ons") +
                    "\n        "
                ),
                _c("span", { staticClass: "icon-caret-down" }),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }